import { render, staticRenderFns } from "./ServiceLimitationSearch.vue?vue&type=template&id=5068740d&"
import script from "./ServiceLimitationSearch.vue?vue&type=script&lang=js&"
export * from "./ServiceLimitationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports